import { fiflboxApi } from '@/utils/api';

const state = {
  publicParentCourses: [],
  parentCourses: [],
  parentCourseCategories: []
};

const mutations = {
  setParentCourseCategories(state, parentCourseCategories) {
    state.parentCourseCategories = parentCourseCategories;
  },
  setParentCourses(state, parentCourses) {
    state.parentCourses = parentCourses;
  },
  setPublicParentCourses(state, publicParentCourses) {
    state.publicParentCourses = publicParentCourses;
  }
};

const getters = {
  getParentCourseCategories: state => {
    return state.parentCourseCategories;
  },
  getParentCourses: state => {
    return state.parentCourses;
  },
  getParentCourseById: state => id => {
    return state.parentCourses.find(parentCourse => parentCourse.id === id);
  },
  getPublicParentCourses: state => {
    return state.publicParentCourses;
  },
  getPublicParentCourseNames: state => {
    return state.publicParentCourses.map(
      publicParentCourse => publicParentCourse.name
    );
  },
  getPublicParentCourseIds: state => {
    return state.publicParentCourses.map(
      publicParentCourse => publicParentCourse.id
    );
  },
  getParentCourseByIds: state => ids => {
    return state.parentCourses.filter(parentCourse =>
      ids.includes(parentCourse.id)
    );
  }
};

const actions = {
  async syncPublicParentCourses({ commit }) {
    let { data: publicParentCourses } = await fiflboxApi.v1.getParentCourses({
      is_public: 1
    });

    commit('setPublicParentCourses', publicParentCourses);
  },
  async syncParentCourses({ commit }, payload = { is_removed: false }) {
    let {
      data: parentCourseCategories
    } = await fiflboxApi.v2.getCourseCategories(payload);
    let parentCourses = [];

    parentCourseCategories.forEach(category => {
      parentCourses = parentCourses.concat(category.parent_courses);
    });

    commit('setParentCourseCategories', parentCourseCategories);
    commit('setParentCourses', parentCourses);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
